import { render, staticRenderFns } from "./specific-google-merchant.vue?vue&type=template&id=46ff5c9d&"
import script from "./specific-google-merchant.vue?vue&type=script&lang=js&"
export * from "./specific-google-merchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports